import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify"; 

import {
  fetchDashboardInfoFailure,
  fetchDashboardInfoRequest,
  fetchDashboardInfoSuccess,
  createDashboardInfoRequest,
  createDashboardInfoSuccess,
  createDashboardInfoFailure,
} from "./DashboardInfoSlice";

function* fetchDashboardInfoSaga(action) {
  try {
    const {pageName = ""} = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard-information/getDashboardInfo`,
        {
          params: {
            pageName,
          },
        }
      )
    );

    const resData = response.data;

    if (resData.success) {
      const info = resData.data || null; 

      yield put(
        fetchDashboardInfoSuccess({
          dashboardInfo: info,
          message: resData.message,
        })
      );
    } else {
      yield put(fetchDashboardInfoFailure(resData.message));
    }
  } catch (error) {
    yield put(fetchDashboardInfoFailure(error.message));
  }
}

// Create Dashboard Info
function* createDashboardInfo(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard-information/saveDashboardInfo`,
      action.payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    yield put(createDashboardInfoSuccess(response.data));
    if (response.data.success == false) {
      toast.error(response.data.message);
    } else {
      toast.success(response.data.message);
    }
    yield put(fetchDashboardInfoRequest({ pageName: action.payload.get("pageName") }));
  } catch (error) {
    yield put(
      createDashboardInfoFailure(error.response?.data?.message || error.message)
    );
  }
}

export function* dashboardInfoSaga() {
  yield takeLatest(fetchDashboardInfoRequest.type, fetchDashboardInfoSaga);
  yield takeLatest(createDashboardInfoRequest.type, createDashboardInfo);
}
